"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AvatarGroup;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _container = _interopRequireDefault(require("./styled/container"));

var _avatars = _interopRequireDefault(require("./avatars"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _counter = _interopRequireDefault(require("./counter"));

/**
 * An AvatarGroup is an element that communicates to the user
 *  that there are many entities associated to an item.
 */
function AvatarGroup(props) {
  var size = props.size,
      className = props.className,
      style = props.style,
      avatars = props.avatars,
      maxAvatars = props.maxAvatars,
      showCounter = props.showCounter;
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: className,
    style: style,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: showCounter
  }, /*#__PURE__*/_react["default"].createElement(_counter["default"], {
    size: size,
    avatars: avatars,
    maxAvatars: maxAvatars
  })), /*#__PURE__*/_react["default"].createElement(_avatars["default"], {
    size: size,
    avatars: avatars,
    showCounter: showCounter,
    maxAvatars: maxAvatars
  }));
}

AvatarGroup.propTypes = {
  /** The size of the AvatarGroup. Valid values are x-small, small, medium, and large.
   * This value defaults to medium. */
  size: _propTypes["default"].oneOf(['x-small', 'small', 'medium', 'large']),

  /** A CSS class for the outer element, in addition to the component’s base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** An array with the Avatars data. */
  avatars: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    initials: _propTypes["default"].string,
    icon: _propTypes["default"].node,
    title: _propTypes["default"].string,
    assistiveText: _propTypes["default"].string
  })),

  /** Specify how many Avatars will render. */
  maxAvatars: _propTypes["default"].number,

  /** This shows a counter with the total value of the number of avatars.
   * It is independent of the number of avatars displayed in the component. */
  showCounter: _propTypes["default"].bool
};
AvatarGroup.defaultProps = {
  size: 'medium',
  className: undefined,
  style: undefined,
  avatars: [],
  maxAvatars: 3,
  showCounter: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/AvatarGroup/index.js
// module id = UcUh
// module chunks = 0